import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/TemperatureSensors.css';
import { FaChevronRight, FaFilePdf, FaEnvelope } from 'react-icons/fa';
import WhatsAppModal from './WhatsAppModal';

import tempImage from '../assets/temp_sensors_main.png';
import switchImg from '../assets/TempIntelligent.png';
import rtdImg from '../assets/rtd.png';
import Tempreture_Transmeter from '../assets/Tempreture Transmeter.png';
import TemperaturePdf from '../assets/Fu-Tech Automation_Pressure_Temperature.pdf';
import IntelligentTemperatureSwitchPdf from '../assets/Fu-tek_Digital Temperature Switch.pdf';
import INTEGRATEDTEMPERATURETRANSMITTER from '../assets/INTEGRATED TEMPERATURE TRANSMITTER.pdf';
import InfraredPdf from '../assets/Fu-tek_Infrared Temperature Measurement.pdf';


import infraredImg from '../assets/infrared_sensor.jpg';
import humidityImg from '../assets/humidity_sensor.jpg';
import DigitaTemperatureandHumiditySensorPdf from '../assets/Digital Temperature and Humidity Sensor.pdf';


export default function TemperatureSensors() {
  const [activeTab, setActiveTab] = useState('switch');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="TemperatureSensors-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner23">
        <div className="hero-banner23-content">
          <h1>TEMPERATURE SENSORS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Temperature sensors</span>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="level-content">
        <div className="level-row">
          <img src={tempImage} alt="Temperature Sensors" />
          <div className="level-description">
            <h2>Temperature Sensors</h2>
            <ul>
              <li>Units with integrated or separate evaluation electronics</li>
              <li>Modular concept for a large variety of applications</li>
              <li>High process safety due to self-monitoring</li>
              <li>Variable process connection using adapters</li>
              <li>High shock and vibration resistance</li>
            </ul>
            <div className="level-buttons">
              <a href={TemperaturePdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
              </a>
              <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}>
                <FaEnvelope /> Request a Quote
              </button>
              <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            </div>
          </div>
        </div>

        {/* Tabs for Categories */}
        <div className="level-tabs">
          <button className={activeTab === 'switch' ? 'active' : ''} onClick={() => setActiveTab('switch')}>Switch Type</button>
          <button className={activeTab === 'rtd' ? 'active' : ''} onClick={() => setActiveTab('rtd')}>RTD Type</button>
          <button className={activeTab === 'transmitter' ? 'active' : ''} onClick={() => setActiveTab('transmitter')}>Transmitter Type</button>
          <button className={activeTab === 'infrared' ? 'active' : ''} onClick={() => setActiveTab('infrared')}>Infrared Sensor</button>
          <button className={activeTab === 'humidity' ? 'active' : ''} onClick={() => setActiveTab('humidity')}>Digital Temp & Humidity</button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">

          {/* Switch Type */}
          {activeTab === 'switch' && (
            <div className="level-product-table">
              <div className="level-product-left">
                <div className="sensor-feature-card">
                  <img src={switchImg} alt="Intelligent Temperature Switch" />
                  <h3>Intelligent Temperature Switch</h3>
                  <a href={IntelligentTemperatureSwitchPdf} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a>
                </div>
              </div>
              <div className="level-card-right">
                <table className="level-spec-table">
<tbody>
  <tr><td>Range</td><td>-50~300°C (Customized available e.g., -50~100°C)</td></tr>
  <tr><td>Display Accuracy (°C)</td><td>±0.3 + (±0.1% MS) <br />MS = set measurement range value</td></tr>
  <tr><td>Display</td><td>OLED</td></tr>
  <tr><td>Response Time</td><td>50ms</td></tr>
  <tr><td>Power</td><td>12~28V</td></tr>
  <tr><td>Output</td>
    <td>
      Output 1: NPN or PNP (switchable)<br />
      Output 2: NPN or PNP (switchable)<br />
      Output 3: 4–20mA
    </td>
  </tr>
  <tr><td>Load Current</td><td>&lt;200mA</td></tr>
  <tr><td>Temperature</td><td>-20~65°C</td></tr>
  <tr><td>Electrical Connections</td><td>M12X1 connector</td></tr>
  <tr><td>Electrical Protection</td><td>Anti-reverse connection protection, anti-electromagnetic interference</td></tr>
  <tr><td>Threaded Interface</td><td>G12 (G1/2), G14 (G1/4), M9 (customized thread)</td></tr>
  <tr><td>Material</td><td>304 stainless steel</td></tr>
  <tr><td>Protection Level</td><td>IP65</td></tr>
  <tr><td>Accessories</td><td>Standard 5-core M12 aviation patch cord (1 meter)</td></tr>
</tbody>
                </table>
              </div>
            </div>
          )}

          {/* RTD Type */}
          {activeTab === 'rtd' && (
            <div className="level-product-table">
              <div className="level-product-left">
                <div className="sensor-feature-card">
                  <img src={rtdImg} alt="RTD" />
                  <h3>RTD</h3>
                  {/* <a href={TemperaturePdf} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a> */}
                </div>
              </div>
              <div className="level-card-right">
                <table className="level-spec-table">
                  <tbody>
                    <tr><td>Range</td><td>-50 ~ 1000°C</td></tr>
                    <tr><td>Output Signal</td><td>Relay Output</td></tr>
                    <tr><td>Supply</td><td>24VDC</td></tr>
                    <tr><td>Accuracy</td><td>0.5%FS (typical)</td></tr>
                    <tr><td>Insertion Diameter</td><td>Φ8</td></tr>
                    <tr><td>Housing</td><td>SS304</td></tr>
                    <tr><td>Protection</td><td>IP65</td></tr>
                    <tr><td>Explosion Proof</td><td>Ex ia IIC T6 Ga</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Transmitter Type */}
          {activeTab === 'transmitter' && (
            <div className="level-product-table">
              <div className="level-product-left">
                <div className="sensor-feature-card">
                  <img src={Tempreture_Transmeter} alt="Temperature Transmitter with PT100" />
                  <h3>Temperature Transmitter with Movable Connector</h3>
                  <a href={INTEGRATEDTEMPERATURETRANSMITTER} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a>
                </div>
              </div>
              <div className="level-card-right">
                <table className="level-spec-table">
                  <tbody>
  <tr><td>Range</td><td>-50~500°C (optional)</td></tr>
  <tr><td>Accuracy</td><td>±0.5%FS / ±0.2%FS</td></tr>
  <tr><td>Output Signal</td><td>4–20mA / PT resistance signal</td></tr>
  <tr><td>Limit Current</td><td>&lt;25mA</td></tr>
  <tr><td>Power Supply</td><td>12~28VDC</td></tr>
  <tr><td>Response Time</td><td>&lt;1 second</td></tr>
  <tr><td>Temperature Drift Coefficient</td><td>0.005% FS/1°C (typ.)</td></tr>
  <tr><td>Environment Temperature</td><td>-40 ~ 80°C</td></tr>
  <tr><td>Probe Diameter</td><td>4mm, 6mm, 8mm, 10mm optional</td></tr>
  <tr><td>Connection</td><td>G1/4 M thread or customized thread</td></tr>
  <tr><td>Connector Material</td><td>316 stainless steel</td></tr>
  <tr><td>Shell Material</td><td>316 stainless steel</td></tr>
  <tr><td>Measuring Medium</td><td>Gas or liquid compatible with 316 stainless steel</td></tr>
  <tr><td>IP Rating</td><td>IP67</td></tr>
  <tr><td>Outlet Method</td><td>M12 waterproof aviation plug / Horsman / straight out</td></tr>
  <tr><td>Product Protection</td><td>Reverse polarity protection/Explosion Proof</td></tr>
</tbody>




                </table>
              </div>
            </div>
          )}



{activeTab === 'infrared' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={infraredImg} alt="Infrared Temperature Sensor" />
        <h3>Infrared Temperature Sensor</h3>
        <a href={InfraredPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>
    <div className="level-card-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Range</td><td>0°C to 2000°C</td></tr>
          <tr><td>Accuracy</td><td>±0.3% of measured value</td></tr>
          <tr><td>Response Time</td><td>&lt;100 ms</td></tr>
          <tr><td>Output</td><td>4~20mA 、0~5V、0~10V RS485</td></tr>
          <tr><td>Working Temperature</td><td>-40~+85℃</td></tr>
          
          <tr><td>Response Wavelength</td><td>8–14 µm</td></tr>
          <tr><td>Optical Resolution</td><td>10:1</td></tr>
          <tr><td>Supply Voltage</td><td>10–30V DC</td></tr>
          <tr><td>Shell Material</td><td>304 Stainless steel</td></tr>
          <tr><td>Protection Class</td><td>IP65</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}


{activeTab === 'humidity' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={humidityImg} alt="Digital Temperature and Humidity Sensor" />
        <h3>Digital Temperature & Humidity Sensor</h3>
        <a href={DigitaTemperatureandHumiditySensorPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>
    <div className="level-card-right">
      <table className="level-spec-table">
<tbody>
  <tr><td>Output</td><td>4–20mA</td><td>RS485</td></tr>
  <tr><td>Protocol</td><td>---</td><td>Modbus RTU</td></tr>
  <tr><td>Power Supply</td><td colSpan="2">12–28VDC</td></tr>
  <tr><td>Measuring Range (Humidity)</td><td colSpan="2">0~100%RH</td></tr>
  <tr><td>Measuring Range (Temperature)</td><td colSpan="2">-20~+100°C</td></tr>
  <tr><td>Humidity Accuracy</td><td colSpan="2">±3%RH</td></tr>
  <tr><td>Temperature Accuracy</td><td colSpan="2">±0.3°C</td></tr>
  <tr><td>Sampling Rate</td><td colSpan="2">2 times/sec</td></tr>
  <tr><td>Resolution</td><td colSpan="2">Temperature: 0.1°C, Humidity: 0.1%RH</td></tr>
  <tr><td>Installation Method</td><td colSpan="2">Wall-mounted</td></tr>
  <tr><td>Response Time</td><td colSpan="2">Temperature: 5s, Humidity: 5s</td></tr>
  <tr><td>Probe</td><td colSpan="2">Dust filter settings</td></tr>
  <tr><td>Installation of Probe</td><td colSpan="2">Integrated / Split probe 1 m / Split probe 2 m</td></tr>
  <tr><td>Product Function</td><td colSpan="2">Unit switch (°C / °F)</td></tr>
</tbody>
      </table>
    </div>
  </div>
)}

        </div>
      </div>

      <Footer />
    </div>
  );
}
